/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';

export class ZoomExtentsCommand extends MapCommand {

    invoke() {
        const mapService = this.deps['mapService'];
        const mapConfig = this.deps['mapConfig'];
        const view = mapService.map.getView();
        view.fit(mapConfig.extent);
        view.setCenter(mapConfig.center);
        this.deactivate$.next();
    }
}
